(function() {
    'use strict';
a3_cabin_reports.factory('ModalDialogResultFactory',ModalDialogResultFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name ModalDialogResultFactory
    * @description 
    *    Modal Dialog Creator
    * @ngInject
    */
function ModalDialogResultFactory() {

        /**
        * Initialize the ModalDialogResult
        * @memberof ModalDialogResultFactory
        */
		function ModalDialogResult() {
			this.IsInsertMode = null;
			this.Object = null;
		}

		var service = {
			createNew : createNew
		}
	
         /**
         * Create a new  ModalDialogResult object
         * @memberof ModalDialogResultFactory
         * @returns {object} object
         */
		function createNew() {
			return new ModalDialogResult();
		}

		return service;
	}

})();
